import { useEffect, useRef } from 'react';

export function Reveal({
  children,
  className = '',
  delay = 0,
  variant = 'lift',
  as: Component = 'div',
  style,
  ...props
}) {
  const element = useRef(null);

  useEffect(() => {
    const node = element.current;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!node || reduceMotion || !('IntersectionObserver' in window)) return undefined;

    const bounds = node.getBoundingClientRect();
    if (bounds.top <= window.innerHeight * 0.92 || bounds.bottom <= 0) return undefined;

    node.classList.add('reveal--pending');
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      node.classList.add('reveal--visible');
      observer.disconnect();
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Component
      {...props}
      ref={element}
      className={`reveal reveal--${variant} ${className}`.trim()}
      style={{ ...style, '--reveal-delay': `${Math.round(delay * 1000)}ms` }}
    >
      {children}
    </Component>
  );
}
